/**
 * 调解员
 */
const App = () => import('@/module/index/layout/App.vue')
const mediatorIndex = () => import('@/module/index/pages/mediator/index.vue')
const mediatordetail = () => import('@/module/index/pages/mediator/detail.vue')
const mediatordossier = () => import('@/module/index/pages/mediator/dossier.vue')
const subPre = () => import('../components/subPre.vue')
const adjust = () => import('@/module/index/pages/mediator/adjust.vue')
const judicialConfirm = () => import('@/module/index/pages/mediator/judicialConfirm.vue')
export default {
  path: '/mediator',
  component: App,
  redirect: '/mediator/index',
  meta: {
    title: '调解员-海南涉外民商事法庭案件多元化解平台',
    requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
    isback: true
  },
  children: [{
    path: '/mediator/index',
    component: mediatorIndex,
    meta: {
      title: '调解员-海南涉外民商事法庭案件多元化解平台'
    }
  },
  {
    path: '/mediator/subPre',
    component: subPre,
    meta: {
      title: '调解员-海南涉外民商事法庭案件多元化解平台'
    }
  },
  {
    name: 'judicialConfirm',
    path: '/mediator/confirm/:id',
    component: judicialConfirm,
    meta: {
      title: '司法确认书'
    }
  },
  {
    name: 'adjust',
    path: '/mediator/adjust/:id',
    component: adjust,
    meta: {
      title: '调解申请书'
    }
  },
  {
    path: '/mediator/index/:id',
    component: mediatordetail,
    meta: {
      title: '调解员-海南涉外民商事法庭案件多元化解平台'
    }
  },
  {
    path: '/mediator/completed',
    component: mediatorIndex,
    meta: {
      title: '调解员-海南涉外民商事法庭案件多元化解平台'
    }
  },
  {
    path: '/mediator/completed/:id',
    component: mediatordetail,
    meta: {
      title: '调解员-海南涉外民商事法庭案件多元化解平台'
    }
  },
  {
    path: '/mediator/completed/dossier/:id',
    component: mediatordossier,
    meta: {
      title: '调解员-海南涉外民商事法庭案件多元化解平台'
    }
  }
  ]
}



// WEBPACK FOOTER //
// ./src/publicResource/router/mediator.js